module.exports = __webpack_public_path__ + "img/thumbnail_RedNeckedWallaby_j_albino.7452c99b.png";